import React, { Component } from "react";

import { Row, Col, Grid } from "react-bootstrap";
import { Button, Message } from "semantic-ui-react";
import { Redirect } from "react-router-dom";

import OSDayCard from "../../OSDayCard/OSDayCard";
import OSDayCardAlt from "../../OSDayCardAlt/OSDayCardAlt";

import moment from "moment";

import "./ItinerariesContent.css";

import ReactGA from "react-ga";

import { translate, getLanguage } from "../../Translation/Translation";

class ItinerariesContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  redirectToShips = () => {
    let newdate = new Date();
    let departureLocation = JSON.parse(
      localStorage.getItem("departureLocation")
    );
    let arrivalLocation = JSON.parse(localStorage.getItem("arrivalLocation"));
    let incomingTrip = JSON.parse(localStorage.getItem("incomingTrip"));
    let outgoingTrip = JSON.parse(localStorage.getItem("outgoingTrip"));

    if (this.props.data.data.settings.isRoundTrip) {
      ReactGA.event({
        category: "Routes",
        action: "SearchRoutes",
        label: `RoundTrip#${moment(this.props.data.match.params.sdate).format(
          "YYYYMMDD"
        )}#${moment(
          this.props.data.data.itineraries.selectedOutgoingTrip
            .departureDateTime
        ).format("hhmm")}#${departureLocation.id}#${
          arrivalLocation.id
        }#2#${moment(this.props.data.match.params.sdate).format(
          "YYYYMMDD"
        )}#${moment(this.props.data.match.params.edate).format(
          "YYYYMMDD"
        )}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
      });
    } else {
      ReactGA.event({
        category: "Routes",
        action: "SearchRoutes",
        label: `OneWayTrip#${moment(this.props.data.match.params.sdate).format(
          "YYYYMMDD"
        )}#${moment(
          this.props.data.data.itineraries.selectedOutgoingTrip
            .departureDateTime
        ).format("hhmm")}#${departureLocation.id}#${
          arrivalLocation.id
        }#1#${moment(this.props.data.match.params.sdate).format(
          "YYYYMMDD"
        )}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
      });
    }
    if (this.props.data.data.settings.isRoundTrip) {
      ReactGA.event({
        category: "Destination",
        action: "SearchDestination",
        label: `SearchDestination#${moment(
          this.props.data.match.params.sdate
        ).format("YYYYMMDD")}#${moment(
          this.props.data.data.itineraries.selectedOutgoingTrip
            .departureDateTime
        ).format("hhmm")}#${arrivalLocation.id}#2#${moment(
          this.props.data.match.params.sdate
        ).format("YYYYMMDD")}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
      });
    } else {
      ReactGA.event({
        category: "Destination",
        action: "SearchDestination",
        label: `SearchDestination#${moment(
          this.props.data.match.params.sdate
        ).format("YYYYMMDD")}#${moment(
          this.props.data.data.itineraries.selectedOutgoingTrip
            .departureDateTime
        ).format("hhmm")}#${arrivalLocation.id}#1#${moment(
          this.props.data.match.params.sdate
        ).format("YYYYMMDD")}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
      });
    }
    ReactGA.event({
      category: "Destination",
      action: "SearchDestination",
      label: `SearchDestination#${moment(
        this.props.data.match.params.sdate
      ).format("YYYYMMDD")}#${moment(
        this.props.data.data.itineraries.selectedOutgoingTrip.departureDateTime
      ).format("hhmm")}#${arrivalLocation.id}#1#${moment(
        this.props.data.match.params.sdate
      ).format("YYYYMMDD")}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
    });
    this.props.data.history.push(
      `/${this.props.data.match.params.from}/${
        this.props.data.match.params.to
      }/${this.props.data.match.params.sdate}/${
        this.props.data.match.params.edate
      }/ships`
    );
    this.setState({ redirect: true });
  };

  componentWillReceiveProps(nextProps) {
    let OutgoingDayCards = [];
    let IncomingDayCards = [];
    let DepartureLocation = null;
    let ArrivalLocation = null;
    let DepartureDay = null;
    let ArrivalDay = null;

    let shouldDisplayReturn = false;

    if (nextProps.data.data.itineraries && nextProps.outgoingTripList) {
      OutgoingDayCards = nextProps.outgoingTripList.map((trip, index) => {
        if (trip.trips && trip.trips.length > 0) {
          DepartureLocation = trip.trips[0].departureLocation;
          ArrivalLocation = trip.trips[0].arrivalLocation;
          this.setState({
            DepartureLocation: DepartureLocation,
            ArrivalLocation: ArrivalLocation
          });
        }
        return (
          <OSDayCard
            key={index}
            tripDay={moment(trip.tripDate)}
            searchDay={
              nextProps.data.data.itineraries &&
              nextProps.data.data.itineraries.searchStartDay
            }
            trips={trip.trips}
            mode="departure"
            data={nextProps.data}
            language={getLanguage()}
          />
        );
      });
    }

    if (
      nextProps.data.data.itineraries &&
      nextProps.data.data.itineraries.IncomingTripList
    ) {
      if (nextProps.data.data.itineraries.IncomingTripList.length > 0) {
        shouldDisplayReturn = this.props.data.data.settings.isRoundTrip;
      }
      IncomingDayCards = nextProps.data.data.itineraries.IncomingTripList.map(
        trip => {
          return (
            <OSDayCard
              key={"In" + trip.tripDate + "|" + trip.id}
              tripDay={moment(trip.tripDate, "YYYY-MM-DD")}
              trips={trip.trips}
              mode="arrival"
              data={nextProps.data}
              language={getLanguage()}
            />
          );
        }
      );
    }

    this.setState({
      OutgoingDayCards,
      IncomingDayCards,
      ArrivalLocation,
      DepartureLocation,
      shouldDisplayReturn
    });
  }

  render() {
    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: `/${this.props.data.data.settings.departurePortCode}/${
              this.props.data.data.settings.arrivalPortCode
            }/${this.props.data.data.settings.startDate}/${
              this.props.data.data.settings.endDate
            }/ships`
          }}
        />
      );
    }

    return (
      <div>
        <Row style={{ margin: "0px", marginTop: "20px" }}>
          {this.props.data.data.settings.departurePortCode !== "ALL" &&
            (this.props.data.data.settings.arrivalPortCode !== "ALL" && (
              <div className="stepLabel" style={{ margin: "0px" }}>
                {translate(getLanguage(), "Departure")}
              </div>
            ))}
          {this.state.DepartureLocation &&
            this.state.ArrivalLocation && (
              <div>
                <div className="portName">
                  {this.state.DepartureLocation.name}
                </div>
                <div className="portArrow">
                  <svg
                    viewBox="0 0 1000 1000"
                    className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
                  >
                    <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
                  </svg>
                </div>
                <div className="portName">
                  {this.state.ArrivalLocation.name}
                </div>
              </div>
            )}
          {this.props.data.data.settings.departurePortCode !== "ALL" &&
          this.props.data.data.settings.arrivalPortCode !== "ALL" ? (
            this.props.data.data.itineraries.selectedOutgoingTrip ? (
              <div>
                <div className="departureDayLabel">
                  {translate(getLanguage(), "Departure Date")}
                </div>
                <div className="departureDayText">
                  {this.props.data.data.itineraries.selectedOutgoingTrip &&
                    moment(
                      this.props.data.data.itineraries.selectedOutgoingTrip
                        .departureDateTime,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("dddd DD MMMM YYYY")}
                </div>
              </div>
            ) : (
              <div>
                <Message negative>
                  <Message.Header>
                    {translate(
                      getLanguage(),
                      "There are no available itineraries for the selected day"
                    )}
                  </Message.Header>
                  <p>
                    {translate(
                      getLanguage(),
                      "Please select an itinerary to proceed"
                    )}
                  </p>
                </Message>
              </div>
            )
          ) : null}
        </Row>

        <Row style={{ margin: "0px", marginTop: "30px", marginBottom: "20px" }}>
          <Button
            style={{ float: "right", position: "relative" }}
            className="searchButton"
            primary
            loading={this.props.isloading}
            onClick={() => this.redirectToShips()}
            disabled={
              this.props.data && this.state.shouldDisplayReturn
                ? !(
                    this.props.data.data.itineraries.selectedIncomingTrip &&
                    this.props.data.data.itineraries.selectedOutgoingTrip
                  )
                : !this.props.data.data.itineraries.selectedOutgoingTrip
            }
          >
            {translate(getLanguage(), "Continue to booking")}
          </Button>
        </Row>
        <Row style={{ margin: "0px", marginTop: "20px" }}>
          <div className="OSDayCardRow">{this.state.OutgoingDayCards}</div>
        </Row>

        {this.state.shouldDisplayReturn && (
          <div>
            <Row style={{ margin: "0px", marginTop: "20px" }}>
              <div className="stepLabel" style={{ margin: "0px" }}>
                {translate(getLanguage(), "Return")}
              </div>
              {this.state.DepartureLocation &&
                this.state.ArrivalLocation && (
                  <div>
                    <div className="portName">
                      {this.state.ArrivalLocation.name}
                    </div>
                    <div className="portArrow">
                      <svg
                        viewBox="0 0 1000 1000"
                        className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1"
                      >
                        <path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
                      </svg>
                    </div>
                    <div className="portName">
                      {this.state.DepartureLocation.name}
                    </div>
                  </div>
                )}

              {this.props.data.data.settings.departurePortCode !== "ALL" &&
              this.props.data.data.settings.arrivalPortCode !== "ALL" ? (
                this.props.data.data.itineraries.selectedIncomingTrip ? (
                  <div>
                    <div className="departureDayLabel">
                      {translate(getLanguage(), "Departure Date")}
                    </div>
                    <div className="departureDayText">
                      {this.props.data.data.itineraries.selectedIncomingTrip &&
                        moment(
                          this.props.data.data.itineraries.selectedIncomingTrip
                            .departureDateTime,
                          "YYYY-MM-DD HH:mm:ss"
                        ).format("dddd DD MMMM YYYY")}
                    </div>
                  </div>
                ) : (
                  <div>
                    <Message negative>
                      <Message.Header>
                        {translate(
                          getLanguage(),
                          "There are no available itineraries for the selected day"
                        )}
                      </Message.Header>
                      <p>
                        {translate(
                          getLanguage(),
                          "Please select an itinerary to proceed"
                        )}
                      </p>
                    </Message>
                  </div>
                )
              ) : null}
            </Row>
            <Row style={{ margin: "0px", marginTop: "20px" }}>
              <div className="OSDayCardRow">{this.state.IncomingDayCards}</div>
            </Row>
          </div>
        )}
        <Row style={{ margin: "0px", marginTop: "30px", marginBottom: "20px" }}>
          <Button
            style={{ float: "right", position: "relative" }}
            className="searchButton"
            primary
            loading={this.props.isloading}
            onClick={() => this.redirectToShips()}
            disabled={
              this.props.data && this.state.shouldDisplayReturn
                ? !(
                    this.props.data.data.itineraries.selectedIncomingTrip &&
                    this.props.data.data.itineraries.selectedOutgoingTrip
                  )
                : !this.props.data.data.itineraries.selectedOutgoingTrip
            }
          >
            {translate(getLanguage(), "Continue to booking")}
          </Button>
        </Row>
      </div>
    );
  }
}

export default ItinerariesContent;



// WEBPACK FOOTER //
// ./src/components/Pages/Itineraries/ItinerariesContent.js